var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.issueClosestToDeprecation)?_c('v-card',{staticClass:"mb-2",attrs:{"to":{
		name: 'invoice',
		params: { id: _vm.issueClosestToDeprecation.invoice.id },
	}}},[_c('v-alert',{staticClass:"mt-0 mb-3",attrs:{"type":_vm.issueClosestToDeprecation.days > 7 ? 'info' : 'warning',"prominent":"","border":"left"}},[_vm._v(" Nästa faktura förfaller om "+_vm._s(_vm.issueClosestToDeprecation.days)+" dagar. ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }